module.exports = __webpack_public_path__ + "img/bg_pno_contact.5a81d3ed.jpg";